import Link from "next/link";
import Router from "next/router";
import Icon from "antd/lib/icon";
import { Modal, Button, Tabs, Switch, Row, Col, message } from "antd";
import { translate } from "react-i18next";
import request from "superagent";
import { getCurrentLang } from "../libs/lang";
import moment from "moment";
import { t as tt } from "../modules/client/lang";
const TabPane = Tabs.TabPane;

class User extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      docCount: 0,
      docExpiredCount: 0,
      probationPassesCount: 0,
      openModal: false,
      modalTab: "document_expired",
      docExpired: [],
      probationPasses: [],
      show_notification: false,
    };
  }

  componentDidMount() {
    const token = localStorage["token"];
    if(localStorage["user"] !== undefined){
      const user = JSON.parse(localStorage["user"]);
      this.setState(user);
   }
    //const user = JSON.parse(localStorage["user"]);
    //this.setState(user);
    this.getNotification();
    request
      .get(`/api/v1/notification?lang=${getCurrentLang()}`)
      .set("Content-Type", "application/json")
      .set("Authorization", "JWT " + token)
      .end((err, res) => {
        if (res.status === 200) {
          const {
            docExpiredCount,
            docExpired,
            probationPasses,
            probationPassesCount,
          } = res.body;
          this.setState({
            docExpired: docExpired || [],
            docExpiredCount: docExpiredCount,
            probationPassesCount: probationPassesCount,
            docCount: docExpired.length + probationPasses.length,
            probationPasses: probationPasses || [],
          });
        }
      });
  }

  getNotification = () => {
    const token = localStorage["token"];
    request
      .get(`/api/v1/notification/show_notification`)
      .set("Content-Type", "application/json")
      .set("Authorization", "JWT " + token)
      .end((err, res) => {
        if (res.status === 200) {
          const data = res.body.data;
          let chk = false;
          if (data && data[0]) {
            chk = data[0].value === "1" ? true : false;
          }

          this.setState({ show_notification: chk });
        }
      });
  };
  handleOnChange = (checked) => {
    const check = checked ? 1 : 0;
    const token = localStorage["token"];
    request
      .post(`/api/v1/notification/show_notification`)
      .set("Content-Type", "application/json")
      .set("Authorization", "JWT " + token)
      .send({ checked: check })
      .end((err, res) => {
        if (res.status == 200) {
          this.getNotification();
        } else {
          message.error("เกิดข้อผิดพลาด");
        }
      });
  };

  // handleViewAll = () => {
  //   if (this.state.modalTab === "document_expired") {
  //     Router.push({
  //       pathname: "/reports/document-expire",
  //       query: { view: "all" },
  //     });
  //     return;
  //   }
  //   if (this.state.modalTab === "probation_period") {
  //     Router.push({
  //       pathname: "/reports/duration-employment",
  //     });
  //   }
  // };

  handleViewAll = () => {

    if (this.state.modalTab === "document_expired") {
      Router.push({
        pathname: "/reports/document-expire"
      });
      return;
    }


    if (this.state.modalTab === "probation_period") {

      //console.log(`probationPasses = ${JSON.stringify(this.state.probationPasses)}`)

      Router.push({
        pathname: "/reports/duration-employment"
      });

    }


  };


  handleStatusProbation = (status) => {
    const { t } = this.props;
    switch (status) {
      case "P":
        return t("components_pages.wait_probationary_status");
      case "Y":
        return t("components_pages.probation_passed");
      case "N":
        return t("components_pages.probation_failed");
      case "X":
        return t("components_pages.probation_extended");
      default:
        return "";
    }
  };

  render() {
    const {
      docCount,
      probationPasses,
      docExpired,
      openModal,
      docExpiredCount,
      probationPassesCount,
    } = this.state;
    const { t } = this.props;
  

    return (
      <div className="user">
        {/* {(this.state.docCount > 0 && (
          <span
            className="notification"
            onClick={() => this.setState({ openModal: true })}
          >
            <Icon type="bell" />
            {this.state.show_notification ? (
              <span className="count">{docExpired.length + probationPasses.length} </span>
            ) : (
              undefined
            )}
          </span>
        )) ||
          null} */}
          
          {/* <span
            className="notification"
            onClick={() => this.setState({ openModal: true })}
          >
            <Icon type="bell" />
            <span className="count">{docExpiredCount + probationPassesCount} </span>
          </span> */}

        <span className="name">
          {t("user.welcome")}&nbsp;{this.state.name}
        </span>
        <span className="setting">
          <Link
            as={`/settings/users/edit/${this.state.id}`}
            href={`/settings/users/edit/${this.state.id}`}
          >
            <a>
              <Icon type="setting" />
            </a>
          </Link>
        </span>
        <Modal
          visible={openModal}
          onCancel={() => this.setState({ openModal: false })}
          footer={[
            <Button
              key="submit"
              type="primary"
              style={{ width: "100%" }}
              onClick={this.handleViewAll}
            >
              {t("pages.view_all")}
            </Button>,
          ]}
        >
          <Row align="middle" justify="end" type="flex">
            <Col>
              <label style={{ margin: "10px" }}>
                {tt("การแจ้งเตือน", "Allow notifications")}
              </label>
              <Switch
                style={{
                  margin: "10px",
                  marginRight: "30px",
                }}
                size="default"
                checkedChildren={tt("เปิด", "Open")}
                unCheckedChildren={tt("ปิด", "Close")}
                defaultChecked={this.state.show_notification}
                onChange={this.handleOnChange}
              />
            </Col>
          </Row>

          <Tabs type="card">
            <TabPane
              tab={
                <div
                  onClick={() =>
                    this.setState({ modalTab: "document_expired" })
                  }
                >
                  {t("pages.modal_document_expired")}
                </div>
              }
              key="document_expired"
            >
              {/* <div className="count-tab">{docExpiredCount} รายการ</div> */}
              <div className="count-tab">{docExpiredCount} รายการ</div>
              <div className="box-item-modal">
                {docExpired.map((item, idx) => {
                  const { doc_expired_head, doc_expire_date, value } = item;
                  const doc_type =
                    (doc_expired_head && doc_expired_head.split(",")[0]) || "";
                  const doc_expire =
                    (doc_expire_date && doc_expire_date.split(",")[0]) || "";
                  return (
                    // <Link
                    //   key={`item-doc-expired${idx + 1}`}
                    //   href={`/reports/document-expire?code=${(value &&
                    //     value[0] &&
                    //     value[0].code) ||
                    //     ""}&doc_type=${doc_type}&doc_expire_date=${doc_expire}`}
                    // >
                      <a
                        className={`item-doc-expired ${(idx % 2 !== 0 &&
                          "background-2") ||
                          ""}`}
                      >
                        <p className="head-doc-expired">{doc_expired_head}</p>
                        <ul>
                          <li>
                            <span>{t("pages.firstname_lastname")}:</span>{" "}
                            {value && getCurrentLang() === "en-US"
                              ? value && value[0] && value[0].prefix_en
                              : value && value[0] && value[0].prefix_th}
                            {value &&
                            value[0] &&
                            value[0] &&
                            getCurrentLang() === "en-US"
                              ? value && value[0] && value[0].name_en
                              : value && value[0] && value[0].name_th}{" "}
                            {value &&
                            value[0] &&
                            value[0] &&
                            getCurrentLang() === "en-US"
                              ? value && value[0] && value[0].lastname_en
                              : value && value[0] && value[0].lastname_th}
                          </li>
                          <li>
                            <span>{t("pages.expired_document_date")}:</span>{" "}
                            {doc_expire_date}
                          </li>
                        </ul>
                      </a>
                    // </Link>
                  );
                })}
              </div>
            </TabPane>
            <TabPane
              tab={
                <div
                  onClick={() =>
                    this.setState({ modalTab: "probation_period" })
                  }
                >
                  {t("pages.modal_probation_period")}
                </div>
              }
              key="probation_period"
            >
              <div className="box-item-modal">
                {/* <div className="count-tab">{probationPassesCount} รายการ</div> */}
                <div className="count-tab">{probationPassesCount} รายการ</div>
                {probationPasses.map((item, idx) => {
                  const {id,code,prefix_en,name_en,lastname_en,prefix_th, name_th, 
                    lastname_th,hire_date,probation_date,Probation_status_th,Probation_status_en} = item;
                  
                  const probation_status = getCurrentLang()== "th-TH" || getCurrentLang()== "th" || getCurrentLang()== "TH" ? Probation_status_th : Probation_status_en
                  const emp_name = getCurrentLang()== "th-TH" || getCurrentLang()== "th" || getCurrentLang()== "TH"  ?`${prefix_th} ${name_th} ${lastname_th}` : `${prefix_en} ${name_en} ${lastname_en}`

                  return (
                    // <Link
                    //   key={`item-doc-expired${idx + 1}`}
                    //   href={`/reports/duration-employment/?emps=${id}`}
                    //   //href={`/organization/structure/employee/create?employee_id=${id}&isEdit=1`}
                    // >
                      <a
                        className={`item-doc-expired ${(idx % 2 !== 0 &&
                          "background-2") ||
                          ""}`}
                      >
                        <p className="head-doc-expired">{`${code} ${emp_name}`}</p>
                        <ul>
                          <li>
                            <span>{t("components_pages.start_day_work")}:</span>{" "}
                            {(hire_date &&
                              moment(hire_date).format("YYYY-MM-DD")) ||
                              "-"}{" "}
                            |{" "}
                            <span>
                              {t("components_pages.probation_end_dates")}:
                            </span>{" "}
                            {(probation_date &&
                              moment(probation_date).format(
                                "YYYY-MM-DD"
                              )) ||
                              "-"}
                          </li>
                          <li>
                            <span>
                              {t("components_pages.probationary_status")}:
                            </span>{" "}
                            {probation_status}
                          </li>
                        </ul>
                      </a>
                    // </Link>
                  );
                })}
                {/* {probationPasses.map((item, idx) => {
                  const {
                    emp_name,
                    date_start,
                    date_end_probation,
                    date_probation_extend,
                    probation_status,
                  } = item;
                  return (
                    <Link
                      key={`item-doc-expired${idx + 1}`}
                      href={`/reports/duration-employment?status=${probation_status}`}
                    >
                      <a
                        className={`item-doc-expired ${(idx % 2 !== 0 &&
                          "background-2") ||
                          ""}`}
                      >
                        <p className="head-doc-expired">{emp_name}</p>
                        <ul>
                          <li>
                            <span>{t("components_pages.start_day_work")}:</span>{" "}
                            {(date_start &&
                              moment(date_start).format("YYYY-MM-DD")) ||
                              "-"}{" "}
                            |{" "}
                            <span>
                              {t("components_pages.probation_end_dates")}:
                            </span>{" "}
                            {(date_end_probation &&
                              moment(date_end_probation).format(
                                "YYYY-MM-DD"
                              )) ||
                              "-"}
                          </li>
                          <li>
                            {(date_probation_extend && (
                              <>
                                <span>
                                  {t(
                                    "components_pages.probation_extended_date"
                                  )}
                                  :
                                </span>{" "}
                                {(date_probation_extend &&
                                  moment(date_probation_extend).format(
                                    "YYYY-MM-DD"
                                  )) ||
                                  "-"}
                                <br />
                              </>
                            )) ||
                              null}
                            <span>
                              {t("components_pages.probationary_status")}:
                            </span>{" "}
                            {this.handleStatusProbation(probation_status)}
                          </li>
                        </ul>
                      </a>
                    </Link>
                  );
                })} */}
              </div>
            </TabPane>
          </Tabs>
        </Modal>
      </div>
    );
  }
}

export default translate()(User);
